import { Button, Dialog, Icons, Intent, Size } from "construct-ui";
// import moment from 'moment';
import Sortable from 'sortablejs';
import { messageComponent } from "../../components/message/message.component";
// import { formats as FORMATS } from '../../config/constants';
import surveyModel from "../../models/survey/survey.model";
import ViewBase from "../view-base.view";
import UploadQuestionsView from "./question-list-upload.view";
import SurveySubCategoryView from "./survey-sub-category.view";

export default function SurveyCategoryView() {
  ViewBase.call(this);
  let onQuestionClicked = (subSurvey, maxId) => { };
  let onDeleteSurvey = (survey) => { };
  let onSaveComplete = () => { };
  let fromUpload = false;
  let surveyId = "";
  let surveyIdString = "";
  let isMsgOpen = false;
  let msgTitle = "";
  let showMsg = "";
  let isOpen = false;
  let isSaveSuccess = false;
  let sortingSurveyList = [];
  // let fromInitDate;
  // let toInitDate;
  let userRoles = [];
  let maxQnId = 0;
  let validationError = "";
  // let sortable;

  let createRandomNumber = () => {
    return Math.floor(Math.random() * 1000000);//generate in between 0 and 1000000

  }

  let _getSurveySequence = (id) => {
    let arr = sortingSurveyList.filter(x => x.code.toString() == id.toString());
    return arr[0].sequence;
  }

  let _getsubSurveySequence = (sid, subId) => {
    let arr = sortingSurveyList.filter(x => x.code.toString() == sid.toString());
    let subArr = arr[0].subSurvey.filter(x => x.code.toString() == subId.toString());
    return subArr[0].sequence;
  }

  let _generatePayload = (items) => {
    validationError = "";
    let id = surveyId;
    let params = {
      surveyId: id,
      categoryList: _generateCategory(items)
    };
    return params;
  }

  let _generateCategory = (items) => {
    let catList = [];
    for (let i = 0; i < items.length; i++) {
      let s = items[i];
      let cnameArr = items.filter(x => x.name == s.name);
      if (cnameArr.length == 1) {//No duplicates
        let sv = {
          category: s.name,
          categoryDispSeq: _getSurveySequence(s.surveyId),//need to set
          subCategoryList: _generateSubCategory(s.surveyId, s)
        };
        catList.push(sv);
        if (validationError != "") {
          break;
        }

      }
      else {
        validationError = this.getText("EM00000394", "Duplicated Category Names are not allowed");
        break;
      }
    }
    return catList;
  }

  let _generateSubCategory = (surveyId, items) => {
    let subCatList = [];
    for (let i = 0; i < items.subSurvey.length; i++) {
      let sb = items.subSurvey[i];
      let cnameArr = items.subSurvey.filter(x => x.name == sb.name);
      if (cnameArr.length == 1) {
        let sv = {
          subCategory: sb.name,
          subCategoryDispSeq: _getsubSurveySequence(surveyId, sb.subSurveyId),//need to set
          questionList: _generateQuestionList(sb)
        };
        subCatList.push(sv);
      }
      else {
        validationError = this.getText("EM00000395", "Duplicated Subcategory Names are not allowed");
        break;
      }
    }
    return subCatList;
  }

  let _generateQuestionList = (items) => {
    let questionList = [];
    items.questions.forEach(function (q) {
      let sv = {
        questionId: q.code,
        questionText: q.questiontext,
        questionType: q.questionType.code,
        dispSeq: q.sequence,
        mandatoryYN: q.mandatory.code,
        parentQuestionId: q.parentQuestion.code == '' ? 0 : q.parentQuestion.code,
        parentOptionId: q.parentAnsId.code == '' ? 0 : q.parentAnsId.code,
        fileMasterId: q.photoGuid,
        optionList: _generateOptionList(q.optionList, items.subSurveyId),
        questionHint: q.questionHint,
        ratingWordsMin: q.ratingWordsMin,
        ratingWordsMax: q.ratingWordsMax,
        photoNumberLimit: q.photoNumberLimit.code.toString() == "" ? "0" : q.photoNumberLimit.code.toString(),
        minValue: q.minValue,
        maxValue: q.maxValue
      };
      questionList.push(sv);
    });
    return questionList;
  }

  let _generateOptionList = (items, qid) => {
    let options = [];
    items.forEach(function (op) {
      let sv = {
        questionId: qid,
        optionId: op.code,
        optionText: op.name,
        dispSeq: op.sequence,
        defaultYN: "N"
      };
      options.push(sv);
    });
    return options;
  }

  let onMsgClosed = (viewState) => {
    isMsgOpen = false;
    if (isSaveSuccess || fromUpload) {
      viewState.clearState();
      onSaveComplete();
      fromUpload = false;
    }
  }

  let _getRadioItemsWithSequence = (id) => {
    let items = document.querySelectorAll('#' + id + ' > li');
    let seq = 1;
    let dtValues = [];
    items.forEach(item => {
      let radioValues = { sequence: "", code: "", subSurvey: [] };
      let txtValue = item.querySelectorAll('input[type=hidden]')[0].value;
      radioValues.sequence = seq.toString();
      radioValues.code = txtValue;
      let subId = "surveyQsSubCategory" + txtValue;
      let subItems = item.querySelectorAll('#' + subId + ' > li');
      let subSeq = 1;
      subItems.forEach(function (subItem) {
        let subValues = { sequence: "", code: "" };
        let txtSubValue = subItem.querySelectorAll('input[type=hidden]')[0].value;
        subValues.sequence = subSeq.toString();
        subValues.code = txtSubValue;
        radioValues.subSurvey.push(subValues);
        subSeq++;
      });
      dtValues.push(radioValues);
      seq++;
    });
    return dtValues;
  }

  let onRegister = (surveyList) => {
    sortingSurveyList = [];
    sortingSurveyList = _getRadioItemsWithSequence("surveyQsM");
    let payload = _generatePayload(surveyList);
    if (validationError == "") {
      this.showLoading();
      surveyModel.saveQuestions(
        (result) => {
          this.hideLoading();
          isSaveSuccess = true;
          isMsgOpen = true;
          showMsg = result[0].message;
          msgTitle = result[0].transStatus;
        }, (error) => {
          isSaveSuccess = false;
          this.hideLoading();
          this.handleError(error);
        },
        payload);
    }
    else {
      isMsgOpen = true;
      showMsg = validationError;
      msgTitle = this.getText("EM00000108", "Validation Error");
    }

  }

  let _addSurvey = (vnode) => {

    let survey = {
      name: "",
      expand: true,
      surveyId: createRandomNumber(),
      subSurvey: [
        {
          name: "",
          subSurveyId: createRandomNumber(),
          questions: []
        }
      ]
    };
    vnode.attrs.survey.push(survey);
  }

  let onQClicked = (subSurvey, maxId) => {
    onQuestionClicked(subSurvey, maxId);
  }

  let _addSubSurvey = (survey) => {
    survey.expand = true;
    let subSurvey = {
      expand: false,
      name: "",
      subSurveyId: createRandomNumber(),
      questions: []
    };
    survey.subSurvey.push(subSurvey);

  }

  let onDelete = (subSurveyId, survey) => {
    let surv = survey.subSurvey.filter(x => x.subSurveyId != subSurveyId);
    survey.subSurvey = surv;
  }

  let downloadTemplate = () => {
    this.showLoading();
    surveyModel.downloadExcelTemplate(
      (result) => {
        this.hideLoading();
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      });
  }

  let downloadQuestionList = () => {
    this.showLoading();
    surveyModel.downloadQuestionList(
      (result) => {
        this.hideLoading();
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      }, surveyId);
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.onDelete) {
        onDeleteSurvey = vnode.attrs.onDelete;
      }

      if (vnode.attrs.surveyId) {
        surveyId = vnode.attrs.surveyId;
      }

      if (vnode.attrs.surveyIdString) {
        surveyIdString = vnode.attrs.surveyIdString;
      }

      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }

      // fromInitDate = moment().add(-1, 'weeks').format(FORMATS.dateFormat);
      // toInitDate = moment().format(FORMATS.dateFormat);
    },

    oncreate: function (vnode) {
      const surveyQsMList = document.getElementById("surveyQsM");
      new Sortable(surveyQsMList, {
          animation: 150,
          ghostClass: 'sortable-ghost',
          dragClass: 'sortable-drag',
          handle: '.drag-grip',
      });
    },
    onupdate: function (vnode) {
      let qnsId = [];
      vnode.attrs.survey.forEach(function (item) {
        item.subSurvey.forEach(function (sItem) {
          sItem.questions.forEach(function (q) {
            qnsId.push(q.code);
          });
        });
      });
      maxQnId = qnsId.length == 0 ? 1 : Math.max.apply(null, qnsId);
    },
    view: (vnode) => {
      if (vnode.attrs.onQuestionClicked) {
        onQuestionClicked = vnode.attrs.onQuestionClicked;
      }

      return [
        m('.d-flex.justify-content-between.mb-3',
          m('h2.mb-2',
            m('i.bi.bi-arrow-left.cursor-pointer', {
              onclick: () => {
                if (confirm(this.getText("EM00000357", "Changes you made may not be saved. Do you want to go back?"))) {
                  onSaveComplete();
                }
              }
            }),
            this.getText("LT00000356", "Survey Question Management")
          ),
          m('.d-grid .gap-2 .d-sm-flex .justify-content-sm-center',
            m('.input-group.w-auto',
              m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText("LT00000500", "Download/Upload")
              ),
              m('ul.dropdown-menu',
                m('li',
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    onclick: downloadTemplate
                  },
                    this.getText("LT00000218", "Download Template")
                  )
                ),
                m('li',
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    class: parseInt(surveyIdString) < 0 ? "disabled-link" : "",
                    onclick: () => { 
                      if (parseInt(surveyIdString) > 0) {
                        isOpen = true; 
                      }
                    }
                  },
                    this.getText("LT00000501", "Upload Question List")
                  )
                ),
                m('li',
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    onclick: downloadQuestionList
                  },
                    this.getText("LT00000502", "Download Question List")
                  )
                ),
              ),
            ),
          )
        ),
        m('.card .mb-3',
          m('.card-body',
            m('.d-flex.mb-3',
              m(Button, {
                iconLeft: Icons.PLUS,
                intent: 'primary',
                label: this.getText("LT00000503", "Add Category"),
                size: Size.SM,
                disabled: parseInt(surveyIdString) < 0,
                onclick: () => { _addSurvey(vnode) }
              })
            ),
            m('ul#surveyQsM.moveable_background-none.p-0',
              vnode.attrs.survey && vnode.attrs.survey.map(survey =>
                m('li.mt-2.drag-grip',
                  m('.survey-category-item',
                    m('.d-flex.align-items-center',
                      m('i.bi-grip-vertical.px-2'),
                      m('.flex-grow-1.pe-3',
                        m('input[type="hidden"][value="' + survey.surveyId + '"]'),
                        m('input[type="text"][value="' + survey.name + '"].form-control',
                          {
                            disabled: parseInt(surveyIdString) < 0,
                            placeholder: this.getText("LT00000348", "Survey Category"),
                            onkeyup: (e) => { survey.name = e.target.value }
                          }),
                      ),
                      m('.d-flex.justify-content-end.align-items-center.gap-4',
                        m('.d-flex.gap-2',
                          m(Button, {
                            iconLeft: Icons.PLUS,
                            intent: Intent.PRIMARY,
                            label: this.getText("", ""),
                            title: this.getText("LT00000504", "Add Sub Category"),
                            outlined: true,
                            rounded: true,
                            disabled: parseInt(surveyIdString) < 0,
                            size: Size.XS,
                            onclick: () => { _addSubSurvey(survey) }
                          }),
                          m(Button, {
                            iconLeft: Icons.TRASH,
                            intent: Intent.NEGATIVE,
                            label: "",
                            title: this.getText("LT00000237", "Remove"),
                            outlined: true,
                            disabled: parseInt(surveyIdString) < 0,
                            rounded: true,
                            size: Size.XS,
                            onclick: () => { onDeleteSurvey(survey); }
                          }),
                        ),
                        m("a.btn.btn-primary.collapse-arrow", {
                          "href": "#survey_" + survey.surveyId,
                          "data-bs-toggle": "collapse",
                          "role": "button",
                          "aria-expanded": survey.expand ? "true" : "false",
                          "aria-controls": "" + survey.surveyId,
                          onclick: () => { survey.expand = !survey.expand }
                        },
                          m("span.search-arrow", [
                            m("i", { "class": survey.expand ? "bi-chevron-down" : "bi-chevron-right" })
                          ])
                        )
                      ),
                    ),
                  ),
                  m('.survey-sub-category-list',
                    m(SurveySubCategoryView, {
                      onQuestionClicked: onQClicked,
                      onDelete: (subSurveyId) => { onDelete(subSurveyId, survey) },
                      surveyId: survey.surveyId,
                      surveyIdString: surveyIdString,
                      subSurvey: survey.subSurvey,
                      expand: survey.expand,
                      maxQnId: maxQnId
                    })
                  )
                )
              )
            ),
            m('.d-flex.gap-2.justify-content-end.mt-5',
              m('button.btn.btn-primary[type=button]', { 
                disabled: parseInt(surveyIdString) < 0,
                onclick: () => onRegister(vnode.attrs.survey) 
              },
                this.getText("LT00000005", "Submit")
              ),
              m('button.btn.btn-white[type=button]', {
                onclick: () => {
                  if (confirm(this.getText("EM00000357", "Changes you made may not be saved. Do you want to go back?"))) {
                    onSaveComplete();
                  }
                }
              },
                this.getText("LT00000021", "Close")
              ),
            )
          ),
        ),
        m(Dialog, {
          isOpen: isOpen,
          onClose: () => { isOpen = false; },
          transitionDuration: 200,
          closeOnOutsideClick: false,
          title: this.getText("LT00000501", "Upload Question List"),
          content: m(UploadQuestionsView, {
            surveyId: surveyId,
            userRoleList: userRoles,
            closeModal: () => { isOpen = false; },
            onUploadCompleted: () => {
              fromUpload = true;
              isMsgOpen = true;
              showMsg = this.getText("EM00000358", "Please check the downloaded excel for the status");
              msgTitle = this.getText("EM00000359", "Upload has been completed");
            }
          }),
          "class": "cui-dialog-sm"
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => onMsgClosed(vnode.attrs.surveyViewState) }),
        this.getBaseViews()
      ];
    }
  }
}
